import React, { useContext } from 'react';
import { Box, Divider, ListItemText } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Theme, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { createStyles, makeStyles } from '@material-ui/styles';
import UserAvatar from '../User/UserAvatar';
import { RootState } from '../../store';
import { handleSignOut, hasPermission } from '../../utils/UserUtils';
import { PortalConfigContext, RouteContext } from '../../context';
import { BaseMenu } from '../Dropdowns/BaseMenu';
import BaseTypography from '../Text/BaseTypography';

import { wideMenuMinWidth } from '../../theme/dimensions';
import { RightSidebarToggle } from '../RightSidebar/RightSidebarToggle';
import { CLIENT_DETAILS_PAGE, PROFILE_PAGE } from '../../constants';
import { GraySmall } from '../../theme/colors';
import { useSettingsPageRedirection } from '../Settings/useSettingsPageRedirection';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    separator: {
      marginLeft: theme.spacing(1.5),
      height: '22px',
    },
  }),
);

const AuthNavbarActions = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const stateModel = useSelector<RootState, Model>(state => ({
    user: state.user,
  }));
  const portalConfig = useContext(PortalConfigContext);
  const { instance } = stateModel.user;
  const isTestUser = Boolean(stateModel?.user?.data?.isTestUser);
  const { attributes } = instance || {};
  const { given_name, family_name, email } = attributes || {};

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { pathname } = useContext(RouteContext);

  const openUserAvatarDropdown = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { goToSettings } = useSettingsPageRedirection(true, PROFILE_PAGE.path);

  const closeUserAvatarDropdown = () => {
    setAnchorEl(null);
  };

  const onSignOut = () => {
    closeUserAvatarDropdown();
    handleSignOut(portalConfig, isTestUser);
  };

  const handleSettingsClicked = () => {
    goToSettings();
    closeUserAvatarDropdown();
  };

  const getUserAvatarActions = () => [
    {
      key: 'item-settings',
      onClick: handleSettingsClicked,
      name: 'Settings',
    },
    {
      key: 'item-signout',
      onClick: onSignOut,
      name: 'Sign out',
    },
  ];

  const menuTitleRenderer = () => (
    <ListItemText
      primary={
        <BaseTypography fontType="15Medium">
          {given_name} {family_name}
        </BaseTypography>
      }
      secondary={
        <BaseTypography fontType="12Regular" component="span">
          {email}
        </BaseTypography>
      }
      secondaryTypographyProps={{
        style: { color: GraySmall },
      }}
    />
  );

  return (
    <>
      {pathname.includes(CLIENT_DETAILS_PAGE.path) && (
        <Box display="flex" alignItems="center" mr={2}>
          <RightSidebarToggle />
          <Divider orientation="vertical" className={classes.separator} />
        </Box>
      )}

      <UserAvatar
        shape="circle"
        type="rowButton"
        onClick={openUserAvatarDropdown}
        showCaret={!isMobile}
        isActive={Boolean(anchorEl)}
      />
      <BaseMenu
        variant="wide"
        menuTitle={menuTitleRenderer()}
        menuProps={{
          id: 'options-menu',
          anchorEl,
          getContentAnchorEl: null,
          keepMounted: true,
          open: Boolean(anchorEl),
          onClose: closeUserAvatarDropdown,
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          transformOrigin: {
            vertical: 0,
            horizontal: 'right',
          },
          style: {
            minWidth: wideMenuMinWidth,
          },
        }}
        actions={getUserAvatarActions()}
      />
    </>
  );
};

export default AuthNavbarActions;
